import { LazyLoadedStates, LazyLoadedStatesManager } from '@edl-development/edl-common';
import { CustomSupervisionActionTypes } from '../custom-supervision/enum/custom-supervision-action-types.enum';


export const CustomSupervisionLazyLoadedStates = new LazyLoadedStatesManager<{
    base: LazyLoadedStates,
    management: LazyLoadedStates,
    my_supervision: LazyLoadedStates,
}> ({
    base: {
        name: 'authenticated.custom-supervision',
        url: '/custom-supervision',
        abstract: true
    },

    my_supervision: {
      name: 'authenticated.custom-supervision.view',
      url: '/my-supervision?page&limit&searchBy&orderBy&ascending',
        params: {
            page: {
                raw: true,
                type: 'int',
                value: 1
            },
            limit: {
                raw: true,
                type: 'int',
                value: 25
            },
            searchBy: {
                raw: true,
                type: 'string'
            }
        }
    },
    management: {
        name: 'authenticated.custom-supervision.management',
        url: '/manage?page&limit&userType&isSupervisorOnly&bid&searchBy&evaluators&orderBy&ascending&actionType&actionEvaluator',
        params: {
            page: {
                raw: true,
                dynamic: true, // Prevents state reload on change
                type: 'int',
                value: 1
            },
            limit: {
                raw: true,
                dynamic: true, // Prevents state reload on change
                type: 'int'
            },
            userType: {
                raw: true,
                type: 'string'
            },
            bid: {
                raw: true,
                type: 'int'
            },
            searchBy: {
                raw: true,
                type: 'string'
            },
            evaluators: {
                raw: true,
                type: 'string',
                array: true
            },
            isSupervisorOnly: {
                raw: true,
                type: 'bool'
            },
            actionType: {
                raw: true,
                dynamic: true, // Prevents state reload on change
                type: 'int',
                value: CustomSupervisionActionTypes.ASSIGN
            },
            actionEvaluator: {
                raw: true,
                dynamic: true, // Prevents state reload on change
                type: 'string'
            }
        }
    }
},
() => import('src/app/custom-supervision/custom-supervision.module').then((result: {CustomSupervisionModule: any}) => result.CustomSupervisionModule)
);
